/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiSanctionAlert,
    ApiSanctionAlertFromJSON,
    ApiSanctionAlertToJSON,
    ApiSanctionAlerts,
    ApiSanctionAlertsFromJSON,
    ApiSanctionAlertsToJSON,
    ApiSanctionEntityType,
    ApiSanctionEntityTypeFromJSON,
    ApiSanctionEntityTypeToJSON,
    SanctionAlertsPage,
    SanctionAlertsPageFromJSON,
    SanctionAlertsPageToJSON,
} from '../models';

export interface FindAllRelatedAlertsByAlertIdV2Request {
    sanctionAlertId: number;
    page: number;
    size: number;
    status?: string;
}

export interface FindAllSanctionAlertsRequest {
    page: number;
    size: number;
    personId: string;
    entityType?: ApiSanctionEntityType;
    statuses?: Array<string>;
}

export interface FindScreeningAlertsByTransactionIdRequest {
    transactionId: string;
}

export interface GetSanctionAlertRequest {
    sanctionAlertId: number;
}

/**
 * 
 */
export class SanctionAlertsApi extends runtime.BaseAPI {

    /**
     * Fetches all related sanction alerts (v2)
     */
    async findAllRelatedAlertsByAlertIdV2Raw(requestParameters: FindAllRelatedAlertsByAlertIdV2Request, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SanctionAlertsPage>> {
        if (requestParameters.sanctionAlertId === null || requestParameters.sanctionAlertId === undefined) {
            throw new runtime.RequiredError('sanctionAlertId','Required parameter requestParameters.sanctionAlertId was null or undefined when calling findAllRelatedAlertsByAlertIdV2.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAllRelatedAlertsByAlertIdV2.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAllRelatedAlertsByAlertIdV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v2/sanctions/alerts/{sanctionAlertId}/related-alerts`.replace(`{${"sanctionAlertId"}}`, encodeURIComponent(String(requestParameters.sanctionAlertId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SanctionAlertsPageFromJSON(jsonValue));
    }

    /**
     * Fetches all related sanction alerts (v2)
     */
    async findAllRelatedAlertsByAlertIdV2(requestParameters: FindAllRelatedAlertsByAlertIdV2Request, initOverrides?: RequestInit): Promise<SanctionAlertsPage> {
        const response = await this.findAllRelatedAlertsByAlertIdV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch all sanction alerts
     */
    async findAllSanctionAlertsRaw(requestParameters: FindAllSanctionAlertsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SanctionAlertsPage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAllSanctionAlerts.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAllSanctionAlerts.');
        }

        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling findAllSanctionAlerts.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.personId !== undefined) {
            queryParameters['personId'] = requestParameters.personId;
        }

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        if (requestParameters.statuses) {
            queryParameters['statuses'] = requestParameters.statuses;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/sanction-alerts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SanctionAlertsPageFromJSON(jsonValue));
    }

    /**
     * Fetch all sanction alerts
     */
    async findAllSanctionAlerts(requestParameters: FindAllSanctionAlertsRequest, initOverrides?: RequestInit): Promise<SanctionAlertsPage> {
        const response = await this.findAllSanctionAlertsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches screening alerts transaction by id
     */
    async findScreeningAlertsByTransactionIdRaw(requestParameters: FindScreeningAlertsByTransactionIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiSanctionAlerts>> {
        if (requestParameters.transactionId === null || requestParameters.transactionId === undefined) {
            throw new runtime.RequiredError('transactionId','Required parameter requestParameters.transactionId was null or undefined when calling findScreeningAlertsByTransactionId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/transactions/{transactionId}/screening-alerts`.replace(`{${"transactionId"}}`, encodeURIComponent(String(requestParameters.transactionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiSanctionAlertsFromJSON(jsonValue));
    }

    /**
     * Fetches screening alerts transaction by id
     */
    async findScreeningAlertsByTransactionId(requestParameters: FindScreeningAlertsByTransactionIdRequest, initOverrides?: RequestInit): Promise<ApiSanctionAlerts> {
        const response = await this.findScreeningAlertsByTransactionIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get sanction alert
     */
    async getSanctionAlertRaw(requestParameters: GetSanctionAlertRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiSanctionAlert>> {
        if (requestParameters.sanctionAlertId === null || requestParameters.sanctionAlertId === undefined) {
            throw new runtime.RequiredError('sanctionAlertId','Required parameter requestParameters.sanctionAlertId was null or undefined when calling getSanctionAlert.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/sanctions/alerts/{sanctionAlertId}`.replace(`{${"sanctionAlertId"}}`, encodeURIComponent(String(requestParameters.sanctionAlertId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiSanctionAlertFromJSON(jsonValue));
    }

    /**
     * Get sanction alert
     */
    async getSanctionAlert(requestParameters: GetSanctionAlertRequest, initOverrides?: RequestInit): Promise<ApiSanctionAlert> {
        const response = await this.getSanctionAlertRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
